import { Injectable } from "@angular/core";
import { HttpService } from "../../utils/services/http.service";
import { Observable } from "rxjs/Observable";
import { SessionStorage } from "ngx-webstorage";
import { DatePipe } from "@angular/common";
import { ErrorsService } from "../../utils/services/errors.service";

@Injectable()
export class TimesheetEntryService {
  @SessionStorage() public user;
  @SessionStorage() public config;
  constructor(
    private httpService: HttpService,
    private errorsService: ErrorsService,
    public datePipe: DatePipe
  ) {}

  /**API to get task list */
  getTaskList(): Observable<any> {
    const data = {
      pageSize: 15,
      pageNumber: "",
    };
    return this.httpService
      .get(`activity/timesheet/list`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }
  getTargetIds(data: any[]): Observable<any> {
    return this.httpService
      .post(`targetId/list`, {projectwbscode:data})
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to get support group */
  getSupportGroup(): Observable<any> {
    const data = {
      pageSize: 15,
      pageNumber: "",
    };
    return this.httpService
      .get(`timesheet/subgroup`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to get project list */
  getLibriesList(): Observable<any> {
    return this.httpService
      .get(`library`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to get project list */
  // getProjectList(): Observable<any> {
  //   return this.httpService
  //     .post(`rm/projectlist`, "")
  //     .map((res: Response) => res.json())
  //     .catch((error: any) => {
  //       return this.handleError(error);
  //     });
  // }
  getProjectList(ops): Observable<any> {
    let data={otherProjectSupport:ops}
    return this.httpService
      .post(`rm/projectlist`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  sendDailyMetricstoGalaxy(week,year): Observable<any> {
    const data={currentWeek:week,currentYear:year};
    return this.httpService
      .post(`timesheet/dailyMetrics/Galaxy`,data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }
  /**API to get project detail*/
  getEmployeeProjectDetails(
    week,
    empNo,
    year,
    getLastProject
  ): Observable<any> {
    const data = {
      weeknumber: Number(week),
      year: Number(year),
      empno: empNo,
      flag: getLastProject ? getLastProject : 0,
    };
    return this.httpService
      .post(`timesheet/list`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to get project detail of specific user */
  getEmployeeProjectDetailsUser(week, empNo, year): Observable<any> {
    const data = {
      weeknumber: Number(week),
      year: Number(year),
      empno: empNo,
    };
    return this.httpService
      .post(`timesheet/list`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to get ticket number*/
  getTicketNumber(data): Observable<any> {
    return this.httpService
      .get(`timesheet/ticketNumber?searchtext=${data}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to get locked status */
  getLockedStatus(): Observable<any> {
    return this.httpService
      .get(`employee/lock/status`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API request to apply advance leave entry */
  applyLeave(data): Observable<any> {
    return this.httpService
      .post(`apply-leave`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }


  /**API to submit employee timesheet*/
saveEmployeeProjectDetails(
  projects,
  userDetails,
  week,
  year,
  leave,
  rejected,
  timesheetID,
  dailyMetrics
): Observable<any> {
  if (!userDetails) {
    userDetails = {
      EmailID: this.user.EmailID,
      Empname: this.user.Empname,
      Empno: this.user.Empno,
      Empno_legacy: this.user.Empno_legacy,
      RMCode: this.user.RMCode,
    };
  } else {
    userDetails = {
      EmailID: userDetails.EmailID,
      Empname: userDetails.Empname,
      Empno: userDetails.Empno,
      Empno_legacy: userDetails.Empno_legacy,
      RMCode: userDetails.RMCode,
    };
  }

  const data = [];
  let activityhrs = [];
  let totalHrs: any = this.config.businessUnit === "accenture" ? 0 : "00:00";
  let totalHrsconvertValue = 0;
  let projectDetails = [];
  let date;
  let totalExist = false;
  let timeId;

  if (rejected) {
    // Rejected timesheet logic
    for (let i = 0; i < 7; i++) {
      projectDetails = [];
      projects.forEach((projectElement) => {
        totalHrs = this.config.businessUnit === "accenture" ? 0 : "00:00";
        totalHrsconvertValue = 0;
        totalExist = false;
        activityhrs = [];

        projectElement.task.forEach((taskElement) => {
          if (
            (taskElement.WeakDetails[i].status == "" ||
              taskElement.WeakDetails[i].status == 1 ||
              taskElement.WeakDetails[i].status == 3) &&
            taskElement.WeakDetails[i].status != "0" &&
            taskElement.WeakDetails[i].status != 2
          ) {
            if (this.config.businessUnit === "accenture") {
              if (taskElement.WeakDetails[i].FilledHrs > 0 || taskElement.WeakDetails[i].filled === true) {
                activityhrs.push({
                  activityName: taskElement.taskType,
                  FilledHrs: taskElement.WeakDetails[i].FilledHrs.toString(),
                  activityID: taskElement.activityID,
                  ticketNumber: taskElement.ticketNumber,
                  ticketDescription: taskElement.ticketDescription,
                  supportGroup: taskElement.supportGroup,
                });
                totalHrs += Number(taskElement.WeakDetails[i].FilledHrs || 0);
                totalExist = taskElement.WeakDetails[i].filled === true;
                date = taskElement.weak[i];
              }
            } else {
              // Non-accenture business units
              if (taskElement.WeakDetails[i].FilledHrs !== "00:00" || taskElement.WeakDetails[i].filled === true) {
                activityhrs.push({
                  activityName: taskElement.taskType,
                  targetID: taskElement.targetID,
                  FilledHrs: taskElement.WeakDetails[i].FilledHrs.toString(),
                  activityID: taskElement.activityID,
                  description: taskElement.taskDescription,
                  taskSpecifics: taskElement.taskSpecifics,
                });

                // Fixed time calculation
                const [hours, minutes] = taskElement.WeakDetails[i].FilledHrs.split(':').map(Number);
                totalHrsconvertValue += (hours * 60) + (minutes || 0);
                totalHrs = this.convertMinsToHrsMins(totalHrsconvertValue);
                totalExist = taskElement.WeakDetails[i].filled === true;
                date = taskElement.weak[i];
              }
            }
          }
        });

        if (this.config.businessUnit === "accenture") {
          if (totalHrs > 0 || (totalHrs === 0 && totalExist)) {
            projectDetails.push({
              projectname: projectElement.projectName,
              activity_hrs: activityhrs,
              totalHrs: totalHrs,
              projectID: projectElement.projectId,
            });
          }
        } else {
          if (totalHrs !== "00:00" || (totalHrs === "00:00" && totalExist)) {
            projectDetails.push({
              projectname: projectElement.projectName,
              activity_hrs: activityhrs,
              totalHrs: totalHrs,
              projectID: projectElement.projectId,
              programName: projectElement.programName,
              projectManager: projectElement.projectManager,
              wbscode: projectElement.wbscode ? projectElement.wbscode : ""
            });
          }
        }
      });

      if (projectDetails.length > 0) {
        projects.forEach((element) => {
          timeId = "";
          for (let j = 0; j < timesheetID.length; j++) {
            if (timesheetID[j]) {
              if (date.getDate() == new Date(timesheetID[j].dateDetails.date)
                .toLocaleString('en-IN', {timeZone: 'Asia/Kolkata', day: 'numeric'})) {
                timeId = timesheetID[j].timesheetID;
              }
            }
          }
        });
        const dailyMetric = dailyMetrics.find(metric => metric.date === date.getDate());
        data.push({
          userDetails: userDetails,
          projectDetails: projectDetails,
          leaveType: leave[i].leaveType,
          approvalStatus: { status: 0, comment: "" },
          dateDetails: {
            date: this.datePipe.transform(date, "yyyy-MM-dd"),
            Week: Number(week),
            Month: date != "" ? date.getMonth() + 1 : "",
            Year: year,
          },
          timesheetID: timeId,
          dailyMetrics: dailyMetric ? {
            stepsCompleted: dailyMetric.stepsCompleted || "0",
            reactionsPerformed: dailyMetric.reactionsPerformed || "0",
            productiveReactions: dailyMetric.productiveReactions || "0",
            successfulReactions:dailyMetric.successfulReactions || "0"
          } : {}
        });
      } else if (leave[i].leaveType != "" && leave[i].active == true) {
        data.push({
          userDetails: userDetails,
          projectDetails: [],
          leaveType: leave[i].leaveType,
          approvalStatus: { status: 0, comment: "" },
          dateDetails: {
            date: projects[0].task[0].weak[i],
            Week: Number(week),
            Month: new Date(projects[0].task[0].weak[i]).getMonth() + 1,
            Year: year,
          },
          timesheetID: timeId
        });
      }
    }
  } else {
    // Non-rejected timesheet logic
    for (let i = 0; i < 7; i++) {
      projectDetails = [];
      projects.forEach((projectElement) => {
        totalHrs = this.config.businessUnit === "accenture" ? 0 : "00:00";
        totalHrsconvertValue = 0;
        totalExist = false;
        activityhrs = [];

        projectElement.task.forEach((taskElement) => {
          if (
            (taskElement.WeakDetails[i].status == "" ||
              taskElement.WeakDetails[i].status == 1 ||
              taskElement.WeakDetails[i].status == 3) &&
            taskElement.WeakDetails[i].status != "0" &&
            taskElement.WeakDetails[i].status != 2
          ) {
            if (this.config.businessUnit === "accenture") {
              if (taskElement.WeakDetails[i].FilledHrs > 0 || taskElement.WeakDetails[i].filled === true) {
                activityhrs.push({
                  activityName: taskElement.taskType,
                  FilledHrs: taskElement.WeakDetails[i].FilledHrs.toString(),
                  activityID: taskElement.activityID,
                  ticketNumber: taskElement.ticketNumber,
                  ticketDescription: taskElement.ticketDescription,
                  supportGroup: taskElement.supportGroup,
                });
                totalHrs += Number(taskElement.WeakDetails[i].FilledHrs || 0);
                totalExist = taskElement.WeakDetails[i].filled === true;
                date = taskElement.weak[i];
              }
            } else {
              // Non-accenture business units
              if (taskElement.WeakDetails[i].FilledHrs !== "00:00" || taskElement.WeakDetails[i].filled === true) {
                activityhrs.push({
                  activityName: taskElement.taskType,
                  targetID: taskElement.targetID,
                  FilledHrs: taskElement.WeakDetails[i].FilledHrs.toString(),
                  activityID: taskElement.activityID,
                  description: taskElement.taskDescription,
                  taskSpecifics: taskElement.taskSpecifics,
                });

                // Fixed time calculation
                const [hours, minutes] = taskElement.WeakDetails[i].FilledHrs.split(':').map(Number);
                totalHrsconvertValue += (hours * 60) + (minutes || 0);
                totalHrs = this.convertMinsToHrsMins(totalHrsconvertValue);
                totalExist = taskElement.WeakDetails[i].filled === true;
                date = taskElement.weak[i];
              }
            }
          }
        });

        if (this.config.businessUnit === "accenture") {
          if (totalHrs > 0 || (totalHrs === 0 && totalExist)) {
            projectDetails.push({
              projectname: projectElement.projectName,
              activity_hrs: activityhrs,
              totalHrs: totalHrs,
              projectID: projectElement.projectId,
            });
          }
        } else {
          if (totalHrs !== "00:00" || (totalHrs === "00:00" && totalExist)) {
            projectDetails.push({
              projectname: projectElement.projectName,
              activity_hrs: activityhrs,
              totalHrs: totalHrs,
              projectID: projectElement.projectId,
              programName: projectElement.programName,
              projectManager: projectElement.projectManager,
              wbscode: projectElement.wbscode ? projectElement.wbscode : ""
            });
          }
        }
      });

      if (projectDetails.length > 0) {
        projects.forEach((element) => {
          timeId = "";
          for (let j = 0; j < timesheetID.length; j++) {
            if (timesheetID[j]) {
              if (date.getDate() == new Date(timesheetID[j].dateDetails.date)
                .toLocaleString('en-IN', {timeZone: 'Asia/Kolkata', day: 'numeric'})) {
                timeId = timesheetID[j].timesheetID;
              }
            }
          }
        });
        const dailyMetric = dailyMetrics.find(metric => metric.date === date.getDate());
        data.push({
          userDetails: userDetails,
          projectDetails: projectDetails,
          leaveType: leave[i].leaveType,
          approvalStatus: { status: 0, comment: "" },
          dateDetails: {
            date: this.datePipe.transform(date, "yyyy-MM-dd"),
            Week: Number(week),
            Month: date != "" ? date.getMonth() + 1 : "",
            Year: year,
          },
          timesheetID: timeId,
          dailyMetrics: dailyMetric ? {
            stepsCompleted: dailyMetric.stepsCompleted || "0",
            reactionsPerformed: dailyMetric.reactionsPerformed || "0",
            productiveReactions: dailyMetric.productiveReactions || "0",
            successfulReactions:dailyMetric.successfulReactions || "0"
          } : {}
        });
      } else if (leave[i].leaveType != "" && leave[i].active == true) {
        data.push({
          userDetails: userDetails,
          projectDetails: [],
          leaveType: leave[i].leaveType,
          approvalStatus: { status: 0, comment: "" },
          dateDetails: {
            date: projects[0].task[0].weak[i],
            Week: Number(week),
            Month: new Date(projects[0].task[0].weak[i]).getMonth() + 1,
            Year: year,
          },
          timesheetID: timeId
        });
      }
    }
  }

  if (data.length > 0) {
    return this.httpService
      .post(`timesheet`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  } else {
    return Observable.throw("No timesheet to submit");
  }
}

/**API to save employee timesheet*/
saveEmployeeAsDraftProjectDetails(
  projects,
  userDetails,
  week,
  year,
  leave,
  timesheetID,
  dailyMetrics
): Observable<any> {
  if (!userDetails) {
    userDetails = {
      EmailID: this.user.EmailID,
      Empname: this.user.Empname,
      Empno: this.user.Empno,
      Empno_legacy: this.user.Empno_legacy,
      RMCode: this.user.RMCode,
    };
  } else {
    userDetails = {
      EmailID: userDetails.EmailID,
      Empname: userDetails.Empname,
      Empno: userDetails.Empno,
      Empno_legacy: userDetails.Empno_legacy,
      RMCode: userDetails.RMCode,
    };
  }

  const data = [];
  let activityhrs = [];
  let totalHrs: any = this.config.businessUnit === "accenture" ? 0 : "00:00";
  let totalHrsconvertValue = 0;
  let timeId;
  let projectDetails = [];
  let date;
  let totalExist = false;

  for (let i = 0; i < 7; i++) {
    projectDetails = [];
    projects.forEach((projectElement) => {
      totalHrs = this.config.businessUnit === "accenture" ? 0 : "00:00";
      totalExist = false;
      activityhrs = [];
      totalHrsconvertValue = 0;

      projectElement.task.forEach((taskElement) => {
        if (
          (taskElement.WeakDetails[i].status == "" ||
            taskElement.WeakDetails[i].status == 1) &&
          taskElement.WeakDetails[i].status != "0" &&
          taskElement.WeakDetails[i].status != 2
        ) {
          if (this.config.businessUnit === "accenture") {
            if (taskElement.WeakDetails[i].FilledHrs > 0 || taskElement.WeakDetails[i].filled === true) {
              activityhrs.push({
                activityName: taskElement.taskType,
                FilledHrs: taskElement.WeakDetails[i].FilledHrs.toString(),
                activityID: taskElement.activityID,
                ticketNumber: taskElement.ticketNumber,
                ticketDescription: taskElement.ticketDescription,
                supportGroup: taskElement.supportGroup,
              });
              totalHrs += Number(taskElement.WeakDetails[i].FilledHrs || 0);
              totalExist = taskElement.WeakDetails[i].filled === true;
              date = taskElement.weak[i];
            }
          } else {
            // Non-accenture business units
            if (taskElement.WeakDetails[i].FilledHrs !== "00:00" || taskElement.WeakDetails[i].filled === true) {
              activityhrs.push({
                targetID: taskElement.targetID,
                activityName: taskElement.taskType,
                FilledHrs: taskElement.WeakDetails[i].FilledHrs.toString(),
                activityID: taskElement.activityID,
                description: taskElement.taskDescription,
                taskSpecifics: taskElement.taskSpecifics,
              });

              // Fixed time calculation
              const [hours, minutes] = taskElement.WeakDetails[i].FilledHrs.split(':').map(Number);
              totalHrsconvertValue += (hours * 60) + (minutes || 0);
              totalHrs = this.convertMinsToHrsMins(totalHrsconvertValue);
              totalExist = taskElement.WeakDetails[i].filled === true;
              date = taskElement.weak[i];
            }
          }
        } else {
          date = taskElement.weak[i];
        }
      });

      if (this.config.businessUnit === "accenture") {
        if (totalHrs > 0 || (totalHrs === 0 && totalExist)) {
          projectDetails.push({
            projectname: projectElement.projectName,
            activity_hrs: activityhrs,
            totalHrs: totalHrs,
            projectID: projectElement.projectId,
          });
        }
      } else {
        if (totalHrs !== "00:00" || (totalHrs === "00:00" && totalExist)) {
          projectDetails.push({
            projectname: projectElement.projectName,
            activity_hrs: activityhrs,
            totalHrs: totalHrs,
            projectID: projectElement.projectId,
            programName: projectElement.programName,
            projectManager: projectElement.projectManager,
            wbscode: projectElement.wbscode ? projectElement.wbscode : ""
          });
        }
      }
    });

    if (projectDetails.length > 0) {
      projects.forEach((element) => {
        timeId = "";
        for (let j = 0; j < timesheetID.length; j++) {
          if (timesheetID[j]) {
            if (date.getDate() == new Date(timesheetID[j].dateDetails.date)
              .toLocaleString('en-IN', {timeZone: 'Asia/Kolkata', day: 'numeric'})) {
              timeId = timesheetID[j].timesheetID;
            }
          }
        }
      });
      const dailyMetric = dailyMetrics.find(metric => metric.date === date.getDate());
      data.push({
        userDetails: userDetails,
        projectDetails: projectDetails,
        leaveType: leave[i].leaveType,
        approvalStatus: { status: 0, comment: "" },
        dateDetails: {
          date: this.datePipe.transform(date, "yyyy-MM-dd"),
          Week: Number(week),
          Month: date != "" ? date.getMonth() + 1 : "",
          Year: year,
        },
        timesheetID: timeId,
        dailyMetrics: dailyMetric ? {
          stepsCompleted: dailyMetric.stepsCompleted || "0",
          reactionsPerformed: dailyMetric.reactionsPerformed || "0",
          productiveReactions: dailyMetric.productiveReactions || "0",
          successfulReactions:dailyMetric.successfulReactions || "0"
        } : {}
      });
    } else if (leave[i].leaveType != "" && leave[i].active == true) {
      projects.forEach((element) => {
        timeId = "";
        for (let j = 0; j < timesheetID.length; j++) {
          if (timesheetID[j]) {
            if (
              date.getDate() ==
              new Date(timesheetID[j].dateDetails.date).getDate()
            ) {
              timeId = timesheetID[j].timesheetID;
            }
          }
        }
      });
      const dailyMetric = dailyMetrics.find(metric => metric.date === date.getDate());
      data.push({
        userDetails: userDetails,
        projectDetails: [],
        leaveType: leave[i].leaveType,
        approvalStatus: { status: 0, comment: "" },
        dateDetails: {
          date: projects[0].task[0].weak[i],
          Week: Number(week),
          Month: new Date(projects[0].task[0].weak[i]).getMonth() + 1,
          Year: year,
        },
        timesheetID: timeId,
        dailyMetrics: dailyMetric ? {
          stepsCompleted: dailyMetric.stepsCompleted || "0",
          reactionsPerformed: dailyMetric.reactionsPerformed || "0",
          productiveReactions: dailyMetric.productiveReactions || "0",
          successfulReactions:dailyMetric.successfulReactions || "0"
        } : {}
      });
    }
  }

  if (data.length > 0) {
    return this.httpService
      .post(`timesheetDraft`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  } else {
    return Observable.throw({ message: "No timesheet to save" });
  }
}

/**API to convert hours to mins*/
convertHoursToMins(hrs: string): number {
  if (!hrs) return 0;
  const [hours, minutes] = hrs.split(':').map(Number);
  return (hours * 60) + (minutes || 0);
}

/**API to convert mins to hours*/
convertMinsToHrsMins(mins: number): string {
  const h = Math.floor(mins / 60);
  let m = mins % 60;
  m = Math.round(m);
  const hrs = h < 10 ? "0" + h : h.toString();
  const mns = m < 10 ? "0" + m : m.toString();
  return `${hrs}:${mns}`;
}
  /**function to handle api error data */
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/timesheet-entry/timesheet-entry.service.ts